//@ts-ignore
import { IS_LONG_TERM_OLYMP_ACCEPTED } from '@yandex-int/k-common/constants';
import { getMe } from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

import { getTeacherProfile } from 'common.components/user/selectors';

export const getShouldShowSpecCourseModalOffer = createSelector([getMe, getTeacherProfile], (me, teacherProfile) => {
    const grantedRights = teacherProfile?.granted_rights;

    if (!grantedRights) {
        return true;
    }

    // @ts-ignore не понимает js-ную переменную IS_LONG_TERM_OLYMP_ACCEPTED
    return !(me?.is_teacher && grantedRights[IS_LONG_TERM_OLYMP_ACCEPTED]);
});
